import { Experiment } from "../../../model/model"
import Evaluator, { EvaluatorRequest, EvaluatorContext, EvaluatorEvaluation } from "../Evaluator"
import ExperimentEvaluation from "./ExperimentEvaluation"
import ExperimentRequest from "./ExperimentRequest"

export default abstract class ExperimentContextualEvaluator<Request extends EvaluatorRequest = EvaluatorRequest> {
  constructor(protected readonly evaluator: Evaluator) {}

  private evaluateInternal(request: Request, context: EvaluatorContext, experiment: Experiment): EvaluatorEvaluation {
    const experimentRequest = ExperimentRequest.by(request, experiment)
    const evaluation = this.evaluator.evaluate(experimentRequest, context)
    if (!(evaluation instanceof ExperimentEvaluation)) {
      throw new Error(`Unexpected evaluation [expected=ExperimentEvaluation, actual=${evaluation.constructor.name}]`)
    }

    const resolvedEvaluation = this.resolve(request, context, evaluation)

    context.addEvaluation(resolvedEvaluation)
    return resolvedEvaluation
  }

  abstract resolve(request: Request, context: EvaluatorContext, evaluation: EvaluatorEvaluation): ExperimentEvaluation

  evaluate(request: Request, context: EvaluatorContext, experiment: Experiment): ExperimentEvaluation {
    const evaluation = context.getEvaluation(experiment) ?? this.evaluateInternal(request, context, experiment)
    return evaluation as ExperimentEvaluation
  }
}
